import styled from '@emotion/styled';

export const BmiHeatbar = styled.div`
  width: 100%;
  height: 14px;

  background: linear-gradient(
    90deg,
    #8b60f4 0%,
    #658fdf 16.67%,
    #69cdd0 35.42%,
    #88e4c3 51.04%,
    #edba5d 68.23%,
    #ed8f66 84.38%,
    #f28689 100%
  );
  border-radius: 21px;
`;
